import i18next from "i18next";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CountUp from "react-countup";
import { Card, CardBody, CardHeader, Col } from "reactstrap";

const TopSellersV2 = (props) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      {props && props.data && props.data.length > 0 && (
        <Col xl={12}>
          <Card className="card-height-100">
            <CardHeader className="align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">
                {t("Common.Statistics By Category")}{" "}
              </h4>
            </CardHeader>

            <CardBody>
              <div className="table-responsive table-card">
                <table className="table table-centered table-hover align-middle table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th className="py-2">{t("Categories.Category")}</th>
                      <th className="py-2">{t("Dashboard.Technicians")}</th>
                      <th className="py-2">{t("Dashboard.Purchases")}</th>
                      <th className="py-2">{t("Dashboard.Purchase Value")}</th>
                      <th className="py-2">{t("Orders.Orders")}</th>
                      <th className="py-2">
                        {t("Dashboard.Daily Average Orders")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.data.map((item, key) => (
                      <tr key={key}>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 me-2">
                              <img
                                src={item?.iconUrl}
                                alt=""
                                className="avatar-sm p-2"
                              />
                            </div>
                            <div>
                              <span className="text-muted">
                                {i18next.language === "ar"
                                  ? item.arabicTitle
                                  : item.title}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <p className="mb-0">
                            <CountUp
                              start={0}
                              end={item.technicians}
                              duration={4}
                            />
                          </p>
                        </td>
                        <td>
                          <p className="mb-0">
                            <CountUp
                              start={0}
                              end={item.purchases}
                              duration={4}
                            />
                          </p>
                        </td>
                        <td>
                          <p className="mb-0">
                            <CountUp
                              start={0}
                              end={item.value}
                              duration={4}
                              decimals={2}
                            />
                          </p>
                        </td>
                        <td>
                          <p className="mb-0">
                            <CountUp start={0} end={item.orders} duration={4} />
                          </p>
                        </td>
                        <td>
                          <p className="mb-0">
                            {(
                              Math.round(item.avgDailyOrders * 100) / 100
                            ).toFixed(2)}
                          </p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      )}
    </React.Fragment>
  );
};

export default TopSellersV2;
